import { QUICK_DEPOSIT_NAMESPACE } from './modules/quick-deposit/quick-deposit.constants.js';
import { quickDeposit } from './modules/quick-deposit/quick-deposit.store.js';
import { RESUME_DEPOSIT_NAMESPACE } from './modules/resume-deposit/resume-deposit.constants.js';
import { resumeDeposit } from './modules/resume-deposit/resume-deposit.store.js';
import Vuex from 'vuex';
import Vue from 'vue';
import { TRANSACTIONS_NAMESPACE, transactions } from './modules/transactions/transactions.store.js';

Vue.use(Vuex);
const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  modules: {
    [TRANSACTIONS_NAMESPACE]: transactions,
    [QUICK_DEPOSIT_NAMESPACE]: quickDeposit,
    [RESUME_DEPOSIT_NAMESPACE]: resumeDeposit
  }
});

export { store };
